import { useCallback, useEffect, useMemo, useState } from 'react';

type UseActionBarReturn = ModelHookResult<{ isSticky: boolean }, undefined>;

export function useActionBar(ref: React.RefObject<HTMLDivElement>): UseActionBarReturn {
	const [isSticky, setIsSticky] = useState(false);

	const isIntersectionObserverSupported = useMemo(
		() => typeof window !== 'undefined' && 'IntersectionObserver' in window,
		[],
	);

	const callBackFunction = useCallback(
		(entries: IntersectionObserverEntry[]) => {
			const [entry] = entries;
			setIsSticky(entry.intersectionRatio < 1 && ref.current !== null);
		},
		[ref],
	);

	useEffect(() => {
		if (!isIntersectionObserverSupported) return undefined;
		const observer = new IntersectionObserver(callBackFunction, { threshold: 1 });
		if (ref.current) observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, [ref, isIntersectionObserverSupported, callBackFunction]);

	return { data: { isSticky } };
}
